import { Permission } from '../services/open-api/open-api-clients';

export interface RouteData {
    header?: string;
    breadcrumbsDisabled?: boolean;
    hasPermission?: Permission | Permission[];
    hasAnyChildModulePermission?: boolean;
}

export function initRouteData(routeData: Readonly<RouteData>): RouteData {
    return routeData;
}
